export const VIEW_TYPES = Object.freeze({
  assessment: "ASSESSMENT_VIEW",
  pools: "POOLS_VIEW"
});
